module.exports = __webpack_public_path__ + "static/img/Yung-Hui Chou.jpg";